
import axiosClient from "../../../../axiosClient"

export default async (data) => {
    const result = await axiosClient.post(`/provide-overall-result`, data)

    return result.data
}
